"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DETAILED_ICON_SIZES = void 0;
var _T_SHIRT_SIZES = require("./T_SHIRT_SIZES");
var DETAILED_ICON_SIZES = Object.freeze({
  sm: _T_SHIRT_SIZES.T_SHIRT_SIZES.sm
});
exports.DETAILED_ICON_SIZES = DETAILED_ICON_SIZES;